import { OrderStatus, WmsStatus } from "./receiptEnums";

export const statuses = {
  [OrderStatus.CREATED]: "已创建",
  [OrderStatus.WAIT_DECLARE]: "待申报",
  [OrderStatus.DECLARED]: "已申报",
  [OrderStatus.RELEASED]: "已放行",
  [OrderStatus.INBOUND_FINISHED]: "入库完成",
  [OrderStatus.CANCELED]: "已取消"
};
export const statusTagTypes = {
  [OrderStatus.CREATED]: "",
  [OrderStatus.WAIT_DECLARE]: "warning",
  [OrderStatus.DECLARED]: "warning",
  [OrderStatus.RELEASED]: "success",
  [OrderStatus.INBOUND_FINISHED]: "success",
  [OrderStatus.CANCELED]: "info"
};
export const wmsStatuses = {
  [WmsStatus.INIT]: "未下发",
  [WmsStatus.WMS_CREATE_SUCCESS]: "下发成功",
  [WmsStatus.WMS_CREATE_EXCEPTION]: "下发失败",
  [WmsStatus.WMS_STOCKIN_FINISHED]: "收货完成",
  [WmsStatus.STOCKOUT_FINISHED]: "出库完成",
  [WmsStatus.WMS_SEND_UNKNOWN]: "下发结果未知",
  [WmsStatus.WMS_CANCEL_UNKNOWN]: "撤单结果未知",
  [WmsStatus.WMS_CANCEL_FAILED]: "仓库撤单失败",
  [WmsStatus.WMS_CANCEL_CONFIRMED]: "仓库已确认撤单"
};
export const wmsStatusTagTypes = {
  [WmsStatus.INIT]: "info",
  [WmsStatus.WMS_CREATE_SUCCESS]: "success",
  [WmsStatus.WMS_CREATE_EXCEPTION]: "danger",
  [WmsStatus.WMS_STOCKIN_FINISHED]: "success",
  [WmsStatus.STOCKOUT_FINISHED]: "success",
  [WmsStatus.WMS_SEND_UNKNOWN]: "warning",
  [WmsStatus.WMS_CANCEL_UNKNOWN]: "warning",
  [WmsStatus.WMS_CANCEL_FAILED]: "danger",
  [WmsStatus.WMS_CANCEL_CONFIRMED]: "info"
};
